var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", [_c("div", {
    staticClass: "canvas",
    style: {
      transform: "scale(" + _vm.scale + ")"
    }
  }, [_vm.showOp ? _c("div", {
    staticClass: "op-wrapper",
    style: {
      top: _vm.sideTop,
      left: _vm.location === "right" ? "auto" : "-60px",
      right: _vm.location === "right" ? "-60px" : "auto"
    }
  }, [_c("a-icon", {
    class: {
      disabled: _vm.index == 0
    },
    attrs: {
      type: "caret-up"
    },
    on: {
      click: _vm.handleMoveUp
    }
  }), _c("a-icon", {
    class: {
      disabled: _vm.iconDownDisabled
    },
    attrs: {
      type: "caret-down"
    },
    on: {
      click: _vm.handleMoveDown
    }
  }), _vm.isShowDelete ? _c("a-icon", {
    attrs: {
      type: "delete"
    },
    on: {
      click: _vm.handleRemove
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.showSimpleOp ? _c("div", {
    staticClass: "op-wrapper",
    style: {
      top: _vm.sideTop,
      left: _vm.location === "right" ? "auto" : "-60px",
      right: _vm.location === "right" ? "-60px" : "auto"
    }
  }, [_c("a-icon", {
    class: {
      disabled: _vm.index === 0
    },
    attrs: {
      type: "caret-up"
    },
    on: {
      click: _vm.handleSimpleMoveUp
    }
  }), _c("a-icon", {
    class: {
      disabled: _vm.index === this.pageData.simple.length - 1
    },
    attrs: {
      type: "caret-down"
    },
    on: {
      click: _vm.handleSimpleMoveDown
    }
  }), _c("a-icon", {
    attrs: {
      type: "delete"
    },
    on: {
      click: _vm.handleSimpleRemove
    }
  })], 1) : _vm._e()]), _c("div", {
    staticClass: "lang"
  }, [_c("span", {
    staticClass: "lang-label",
    on: {
      click: function click($event) {
        _vm.showLangDialog = !_vm.showLangDialog;
      }
    }
  }, [_c("svg", {
    staticClass: "icon universe",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c("use", {
    attrs: {
      "data-v-0389ecbe": "",
      "xlink:href": "#icon-a-32-Universe"
    }
  })]), _c("span", [_vm._v(_vm._s(_vm.lang))]), _c("svg", {
    staticClass: "icon down",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c("use", {
    attrs: {
      "data-v-0389ecbe": "",
      "xlink:href": "#icon-a-32-ArrowDown"
    }
  })])]), _vm.showLangDialog ? _c("div", {
    staticClass: "lang-dialog"
  }, _vm._l(_vm.langList, function (item, i) {
    return _c("div", {
      key: i,
      staticClass: "lang-dialog-item",
      on: {
        click: function click($event) {
          return _vm.handleLangChange(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };